<template>
  <div class="edit">

    <div class="title row" v-if="!seen">
      <div class="login">
        <span v-if="isAuth" @click="signout" title="se déconnecter"><v-icon class="edit m8" name="power-off"/></span>
        <span v-else @click="signin()" title="s'identifier"><v-icon class="edit m8" name="user"/></span>
      </div>
      <!--<label for="email">Sujet :</label>-->
      <title class="color bold larger text-center" v-on:click="onclick">
        <!--{{paper.title}}-->
      </title>
      <div class="action">
        <span v-if="canSave">
          <router-link :to="link" v-on:click.native="save" title="Enregistrer">
            <v-icon class="m8" name="save"/>
          </router-link>
        </span>  
        <span v-if="canEdit">
          <!--<router-link :to="upload" title="Ajouter des photos"><v-icon class="m8" name="plus"/></router-link>-->
          <span @click="add" title="Ajouter des images"><v-icon class="m8" name="plus"/></span>
          <span @click="del" title="Supprimer des images"><v-icon class="m8" name="minus"/></span>
          <!--<span v-if="isAdmin">-->
            <span v-if="published" @click="pub" title="Masquer"><v-icon class="m8" name="lock"/></span>
            <span v-else @click="pub" title="Publier"><v-icon class="m8" name="unlock"/></span>
          <!--</span>  -->
          <router-link v-if="paper.key" :to="link" v-on:click.native="remove" title="Supprimer">
            <v-icon class="edit m8" name="trash"/>
          </router-link>
          <router-link :to="link" title="Quitter">
            <v-icon class="m8" name="share"/>
          </router-link>
        </span>
      </div>
    </div>
    <!--<input ref="title" v-if="seen" v-on:blur="onblur" placeholder="Titre"-->
           <!--class="title-input color bold larger text-center row" type="text" :value="paper.title"/>-->
    <div class="row" v-if="!isAuth">
      <label for="email">Email:</label>
      <input ref="email" v-on:blur="onblur" class="input" type="email" id="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" size="30" required>
    </div>
    <div class="row" v-if="!seen">
      <label for="objet">Objet:</label>
      <input ref="objet" v-on:blur="onblur" class="input" type="text" id="objet" size="100" required :value="paper.title">
    </div>
    <label>Message:</label>
    <ckeditor :editor="editor" v-model="editorContent" @input="onblur"></ckeditor>
    <div class="item box thumb" v-for="file in files" v-bind:key="file.name">
      <v-img :src="paper.image(file)"/>
      <input ref="files" class="check" type="checkbox" :file="file">
    </div>
    <input ref="fileInput" v-on:change="upload" id="fileInput" type="file" multiple="multiple" accept="image/*" hidden>

    <div class="row send" v-if="canSend">
      <router-link :to="link" v-on:click.native="save" title="Envoyer">
        <input class="button" type="button" value="Envoyer">
      </router-link>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import CKEditor from '@ckeditor/ckeditor5-vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import UserService from '../../services/user.service'
  import PaperService from '../../services/paper.service'

  Vue.use( CKEditor );

  const moment = require('moment')

  const API = process.env.VUE_APP_API
  const PATH = process.env.VUE_APP_PATH
  const WRITE_API = API + "?file=" + PATH
  const REMOVE_API = API + "?remove=" + PATH
  const EMAIL_API = "https://www.asspm.fr/app/mail.php"
  const EMAIL_TO = "florent.blin@gmail.com;antieredouard@gmail.com"

  export default {
    context: {
      auth: {
        type: Object,
        default: null
      }
    },    
    name: 'Edit',
    props: {},
    components: {
      CKEditor
    },
    created() {
      this.paper = {} //_.clone(this.default);
    },
    mounted() {
      console.log("WRITE_API", WRITE_API);
      console.log("REMOVE_API", REMOVE_API);
      this.state()
      const deeplink = _.get(this, "$route.params.id")
      this.link = "/edit";
      if (!_.isNil(deeplink)) {
        this.link = "/news/" + deeplink
        this.$root.$data.paper.deeplink(deeplink)
          .then(paper => {
            if (_.isNil(paper.key)) paper = {}//_.clone(this.default)
            this.paper = paper
            this.files = this.paper.files;
            console.log("this.paper", this.paper)
            console.log("this.files", this.files)
            var content = this.paper.content()
            this.editorContent = content
            this.published = this.paper.published
            this.state()
          })
      }
    },
    methods: {
      state() {
        this.isAdmin = UserService.isAdmin();
        this.isAuth = UserService.isAuth();
        const exists = !_.isEmpty(this.paper.created)
        this.canEdit = PaperService.canEdit(this.paper) && exists;
        const canSave = (!exists || this.canEdit) && this.paper.title && this.paper.html;
        this.canSave = canSave && this.isAuth
        this.canSend = canSave && !this.isAuth && this.paper.email
        console.log("can save", this.canSave)
      },
      signout() {
        console.log("signout")
        UserService.signout()
        this.state()
      },
      signin: function () {
        console.log('signin')
        const email = _.get(this, "$refs.email.value")
        UserService.signin(email)
          .then(() => this.state());
      },
      
      upload() {
        const files = this.paper.files || [];
        return Promise.all(_.map(Array.from(this.$refs.fileInput.files) || [], (file) => {

          /* file name */
          var date = moment(_.get(this, "paper.created")).toDate();
          var dir = date.getFullYear() + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/";
          var fileName = dir + file.name;

          files.push(fileName);

          /* post */
          var fd = new FormData();
          fd.append("data", file);
          console.log("WRITE_API", WRITE_API + fileName)

          return this.axios.post(WRITE_API + fileName, fd, {headers: {'Content-Type': file.type}})
        })).then(() => {
          this.paper.files = _.uniq(_.compact(files))
          this.files = this.paper.files;
          this.$root.$data.paper.save(this.paper)
          this.$msg({text: 'File upload complete.'})
          this.$refs.fileInput.value = ""
        })
      },

      add() {
        this.$refs.fileInput.focus();
        this.$refs.fileInput.click();
      },

      del() {
        //var checkedList = document.querySelectorAll("input[type^='item[']:checked")
        _.filter(this.$refs.files, f => f.checked).map(f => {
          const file = f.attributes["file"].value
          console.log("REMOVE_API", REMOVE_API + file)
          return this.axios.get(REMOVE_API + file)
            .then(() => {
              this.paper.files = _.filter(this.paper.files, f => f != file);
              this.files = this.paper.files
              this.$root.$data.paper.save(this.paper)
              this.$msg({text: 'File remove complete.'})
            })
        })
      },

      pub() {
        const auth = this.$context.get('auth');
        this.paper.email = _.get(auth, "email", this.paper.email)
        this.paper.published = !_.get(this.paper, "published", false)
        this.published = this.paper.published
        this.$root.$data.paper.save(this.paper)
      },

      save() {
        const auth = this.$context.get('auth');
        this.paper.email = _.get(auth, "email", this.paper.email)
        this.paper.html = _.get(this, "editorContent")
        if (_.isNil(this.paper.deeplink)) {
          return this.$msg({text: 'Titre non valide.'});
        }

        /* Save */
        this.$root.$data.paper.save(this.paper)

        /* Send email */
        const data = {
          to: EMAIL_TO,
          subject: this.paper.title,
          message: "Message de : " + this.paper.email + "<br/><br/>" +  this.paper.html
        }
        console.log("Send mail", data)
        const params = new URLSearchParams();
        params.append('to', data.to);
        params.append('subject', data.subject);
        params.append('message', data.message);
        this.axios.post(EMAIL_API, params)
      },

      remove() {
        this.link = "/news";
        this.$root.$data.paper.remove(this.paper)
      },

      onclick() {
        this.seen = !this.seen
        if (this.seen) _.delay(() => this.focusInput());
      },

      onblur() {
        this.paper.email = _.get(this, "$refs.email.value")
        this.paper.title = _.get(this, "$refs.objet.value")
        this.paper.html = _.get(this, "editorContent")
        const created = _.get(this.paper, "created", moment().format("DD-MM-YYYY"))
        _.assign(this.paper, {
          deeplink: _.kebabCase(this.paper.title + " " + _.split(created, " ")[0])
        })
        this.link = "/news/" + this.paper.deeplink;
        //this.seen = !this.seen
        this.state()
      },

      focusInput() {
        _.invoke(_.get(this, "$refs.title"), "focus");
      }

    },
    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {
          // The configuration of the editor.
        },
        paper: {},
        files: [],
        editorContent: "",
        seen: false,
        link: "/edit",
        //default: {title: ""},
        isAuth: false,
        canEdit: false,
        canSave: false,
        canSend: false,
        published: false
      }
    }
  }
</script>

<style scoped lang="stylus">
  .edit
    label
      margin-right 20px
    .send
      text-align center
    .input
      border-color #d6d6d6
      border-style solid
      border-radius 2px
      border-width 1px
      width 100%
      box-sizing border-box
      font-size unset
    input:invalid {
      background-color: pink;
    }
    .button
      color white
      background-color #7abcff
      border-color gray
      border-style solid
      border-width 1px
    .title
      text-align center
    .login
      float left
      margin-top 5px
    .action
      float right
      margin-top 5px
    title
      display inline-block
      max-width 500px
    .title-input
      display block
      width 100%
      box-sizing: border-box
      border 0
      /*margin 0*/
      padding 0
    .content
      width 100%
      height 500px
    .thumb
      width 175px
      display inline-grid
      margin 5px 5px 0 0
      position relative
      .check
        position absolute
        top 0
</style>
